<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :toolbar-config="tableToolbar"
    :loading="loading"
    :height="height"
    size="mini"
    resizable
    border
    :radio-config="{ highlight: true, trigger: 'row' }"
    :checkbox-config="{
      trigger: 'row',
      highlight: true
    }"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    height: { type: Number, default: 300 },
    isCheckBox: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      tableColumns: tableColumns(this, this.isCheckBox)
    }
  },
  methods: {
    getRadioRecord() {
      const $vxeGrid = this.$refs.vxeGrid
      const data = this.isCheckBox
        ? $vxeGrid.getCheckboxRecords()
        : $vxeGrid.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据！',
          type: 'warning'
        })
        return
      }
      if (this.isCheckBox) {
        if (!data.length) {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_select_data') || '请选择数据！',
            type: 'warning'
          })
        }
      }
      return data
    }
  }
}
</script>
